module.exports = {
  emptyMessage: 'Please enter the expiration date of the card',
  expiredMessage: 'Oops! The card you entered has expired',
  defaultMessage: 'Expiration date is invalid',
};
